import React from "react";
import "../../styles/aboutUs.css";
import About from "../../assets/blog1.jpeg";


const AboutUs = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        
        {/* LEFT SIDE: IMAGE */}
        <div className="about-image-side">
          <img 
            src={About} 
            alt="Classroom" 
            className="about-img"
          />
        </div>

        {/* RIGHT SIDE: TEXT */}
        <div className="about-text-side">
          <h2 className="about-title">About Us</h2>
          
          <p className="about-description">
            <i>At Madhi Academy</i>, students get expert guidance, personal attention, daily 
            tuition support, easy study materials, and English communication training for 
            all-round academic success.
          </p>

          {/* FEATURE LIST */}
          <div className="about-features">
            <div className="feature-item">
              <div className="icon-circle">
                <i className="bi bi-book-half"></i>
              </div>
              <span className="feature-text">Monday to Friday tuition + doubt clearing sessions.</span>
            </div>

            <div className="feature-item">
              <div className="icon-circle">
                <i className="bi bi-book-half"></i>
              </div>
              <span className="feature-text">Personalised Support for weak subjects.</span>
            </div>

            <div className="feature-item">
              <div className="icon-circle">
                <i className="bi bi-book-half"></i>
              </div>
              <span className="feature-text">Exam Revision Camps before finals.</span>
            </div>

            <div className="feature-item">
              <div className="icon-circle">
                <i className="bi bi-book-half"></i>
              </div>
              <span className="feature-text">Monthly Progress Report for parents.</span>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutUs;